// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"f0e9c756","631":"bfa3bdbb","654":"77bbbe86"}[chunkId] + ".chunk.js";
};